export default __webpack_public_path__ + "static/media/logo_pexr.0f0e6d47.png";